import React from 'react';
import ReactPixel from 'react-facebook-pixel';
import { scriptInsert } from './Helpers';



function Tracking() {

    // Global site tag (gtag.js) - Google Analytics
    scriptInsert('https://www.googletagmanager.com/gtag/js?id=UA-135921844-4', true);
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-135921844-4');

    const advancedMatching = { }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
    const options = {
        autoConfig: true, // set pixel's autoConfig
        debug: false, // enable logs
        };
    ReactPixel.init('643430139469971', advancedMatching, options);
    ReactPixel.pageView(); // For tracking page view

  return (
    <noscript><img alt="" height="1" width="1" style={{ display: 'none' }} src="https://www.facebook.com/tr?id=643430139469971&ev=PageView&noscript=1" /></noscript>
  );
}

export default Tracking;